export default {
  fontSizes: [
    12, 14, 16, 20, 24, 32, 48, 64
  ],
  interface: {
    background: '#181818',
    textColor: 'white'
  },
  colors: {
    white: '#fff',
    blue: '#07c',
    lightgray: '#f6f6ff'
  },
  space: [
    0, 4, 8, 16, 32, 64, 128, 256
  ],
  fonts: {
    sans: '-apple-system,BlinkMacSystemFont,"Segoe UI",Helvetica,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"',
    mono: 'Courier, Menlo, monospace',
  },
  shadows: {
    small: '0 0 4px rgba(0, 0, 0, .125)',
    large: '0 0 24px rgba(0, 0, 0, .125)'
  }
}



// WEBPACK FOOTER //
// ./src/docs/theme.js